
// import { useEffect, useState } from "react";
// import useLogin from "../hooks/useLogin";
// import { getAssets } from "remote_app/assets";

// export default function Login() {
//   const { email, setEmail, handleSubmit, isValid } = useLogin();

//   const [Button, setButton] = useState<any>(null);

//   const [Input, setInput] = useState<any>(null);

//       const ASSETS = getAssets("HOST1_SECRET");

//   useEffect(() => {
//     import("remote_app/Button").then((mod) => {
//       setButton(() => mod.default);
//     });

//     import("inputfield/Input").then((mod) => {
//       setInput(() => mod.default);
//     });
//   }, []);

//   if (!Button || !Input) {
//     return <div>Loading...</div>;
//   }

//   return (
//     <div className="w-full max-w-[280px] md:max-w-[511px] mx-auto min-h-[30vh] flex flex-col justify-center ">
//       <h2 className="text-center text-[18px] md:hidden font-medium mb-6">
//         Login
//       </h2>
//        <div className="absolute top-2 right-2 w-[41px] h-[41px]">

//                   <img
//                     src={ASSETS.icon11}
//                     className="w-[44px] h-[44px]"
//                   />
//                 <img
//                     src={ASSETS.bg1}
//                     className="w-[44px] h-[44px]"
//                   />
//                 </div>

//       <Input
//         token="my-secret-token"
//         value={email}
//         onChange={setEmail}
//         placeholder="Enter your Email ID"
//         showStar={false}
//         className="w-full h-[45px] md:h-[51px] rounded-xl border px-4 text-[12px] md:text-[16px]"
//       />

//       <Button
//         token="my-secret-token"
//         onClick={handleSubmit}
//         disabled={!isValid}
//         className={`mt-20 w-full h-[45px] md:h-[51px] rounded-xl font-bold font-montserrat ${
//           isValid
//             ? "bg-[#CF0018] text-white"
//             : "bg-gray-300 text-[#827C7C]"
//         }`}
//       >
//         Submit
//       </Button>
//        <img
//                     src={ASSETS.icon4}
//                     className="w-[44px] h-[44px]"
//                   />
//     </div>
//   );
// }











import { useEffect, useState } from "react";
import type { ComponentType } from "react";import useLogin from "../hooks/useLogin";
import useRemoteAssets from "../utils/useRemoteAssets";
export default function Login() {
  const { email, setEmail, handleSubmit, isValid } = useLogin();

  const [Button, setButton] =
  useState<RemoteComponent | null>(null);

  const [Input, setInput] = useState<RemoteComponent | null>(null);

  const ASSETS = useRemoteAssets();

  const authToken = sessionStorage.getItem("AUTH_TOKEN");
type RemoteComponent =
  ComponentType<Record<string, unknown>>;
  useEffect(() => {
    import("remote_app/Button").then((mod) => {
      setButton(() => mod.default);
    });

    import("inputfield/Input").then((mod) => {
      setInput(() => mod.default);
    });
  }, []);

  if (!ASSETS || !Button || !Input) {
    return <div>Loading...</div>;
  }

  return (
    <div className="w-full max-w-[280px] md:max-w-[511px] mx-auto min-h-[30vh] flex flex-col justify-center ">
      <h2 className="text-center text-[18px] md:hidden font-medium mb-6">
        Login
      </h2>
       <div className="absolute top-2 right-2 w-[41px] h-[41px]">

                  <img
                    src={ASSETS.icon11}
                    className="w-[44px] h-[44px]"
                  />
                <img
                    src={ASSETS.bg1}
                    className="w-[44px] h-[44px]"
                  />
                </div>

      <Input
        token={authToken}
        value={email}
        onChange={setEmail}
        placeholder="Enter your Email ID"
        showStar={false}
        className="w-full h-[45px] md:h-[51px] rounded-xl border px-4 text-[12px] md:text-[16px]"
      />

      <Button
        token={authToken}
        onClick={handleSubmit}
        disabled={!isValid}
        className={`mt-20 w-full h-[45px] md:h-[51px] rounded-xl font-bold font-montserrat ${
          isValid
            ? "bg-[#CF0018] text-white"
            : "bg-gray-300 text-[#827C7C]"
        }`}
      >
        Submit
      </Button>
       <img
                    src={ASSETS.icon4}
                    className="w-[44px] h-[44px]"
                  />
    </div>
  );
}